import React from 'react';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useUser, inExperiment } from '@reverbdotcom/commons/src/user_hooks';
import UserPrivacyConsentContainer, { showUserPrivacyConsent } from '../user_privacy_consent_container';
import PromotionalBannerTop, { ISiteBanner } from './promotional_banner_top';
import ReverbHeader from './reverb_header/reverb_header';
import SecondaryNagBanner from './secondary_nag_banner';
import { useMediaQuery } from '@reverbdotcom/cadence/components';
import SimpleReverbHeader from './reverb_header/simple_reverb_header';
import { useURL } from '@reverbdotcom/commons/src/url_context';
import { isListingExperienceURL } from '@reverbdotcom/commons/src/url_helpers';

interface IProps {
  loginComponent?: React.ReactNode; // used to pass in an oauth login component from sandbox layout.tsx
  siteBanner?: ISiteBanner;
  siteBannerHasSearch?: boolean;
  siteBannerHasLinks?: boolean;
}

export function ReverbHeaderZone({ loginComponent, siteBanner, siteBannerHasSearch = false, siteBannerHasLinks = false }: IProps) {
  const user = useUser();
  const url = useURL();
  const showSecondaryNagBanner = (inExperiment(user, experiments.SECONDARY_HOMEPAGE_BANNER));
  const showUserPrivacyConsentContainer = showUserPrivacyConsent(user);
  const isMobile = useMediaQuery('mobile');
  const shouldHideSiteSearch = isMobile && siteBannerHasSearch;
  const shouldHideHeaderLinks = isMobile && siteBannerHasLinks;

  if (isListingExperienceURL(url)) return <SimpleReverbHeader loginComponent={loginComponent} />;

  return (
    <>
      <PromotionalBannerTop siteBanner={siteBanner} />
      <ReverbHeader loginComponent={loginComponent} shouldHideSiteSearch={shouldHideSiteSearch} shouldHideHeaderLinks={shouldHideHeaderLinks} />
      {showSecondaryNagBanner && <SecondaryNagBanner />}
      {showUserPrivacyConsentContainer && <UserPrivacyConsentContainer />}
    </>
  );
}

export default ReverbHeaderZone;
